import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";

export async function ListProductoAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<ProductoInterface>> {
  const { data } = await apiClient.get<ProductoInterface>(
    "/gpProductos",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Productos obtenidas correctamente",
  };
}
